var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 76,
    width: 360,
    height: 360,
    rx: 180,
    stroke: "#5f9098",
    strokeWidth: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.858 317.867C321.998 336.008 289.291 345.834 255.709 345.834C222.127 345.834 189.408 336.008 161.549 317.867L146 333.416C178.178 355.444 216.512 367.43 255.709 367.43C294.906 367.43 333.239 355.444 365.418 333.416L349.858 317.867Z",
    fill: "#5f9098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.436 324.238C293.167 324.238 322.225 295.18 322.225 259.449C322.225 226.774 271.625 162.709 265.859 155.517L257.436 145L249.014 155.517C243.237 162.709 192.648 226.774 192.648 259.449C192.648 295.18 221.705 324.238 257.436 324.238ZM257.436 179.921C276.787 205.75 300.629 242.993 300.629 259.449C300.629 283.27 281.257 302.642 257.436 302.642C233.616 302.642 214.244 283.27 214.244 259.449C214.244 243.014 238.086 205.761 257.436 179.921Z",
    fill: "#5f9098"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.131 259.449H270.934C270.934 266.9 264.876 272.947 257.436 272.947V289.144C265.309 289.135 272.857 286.004 278.424 280.437C283.991 274.87 287.123 267.322 287.131 259.449Z",
    fill: "#5f9098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupply);
export default __webpack_public_path__ + "static/media/waterSupply.c6719d115f6321274c00676738c6d751.svg";
export { ForwardRef as ReactComponent };